/**
 * Created by cahyo wibowo on 1/4/19
 */

export default (value: any, symbol: string = 'Rp. ') => {
  let valFormated = typeof value === 'string' ? parseInt(value) : typeof value === 'number' ? value : 0;

  return `${symbol} ` + valFormated.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
}
